export const parseApiError = async (response, options = {}) => {
  const data = await response.json().catch(() => null)
  return normalizeApiError(response.status, data, options)
}

export const normalizeApiError = (status, data, options = {}) => {
  const uploadFileLimitLabel = String(options.uploadFileLimitLabel || '2 GB').trim() || '2 GB'
  const errorCode = String(data?.errorCode || '').trim()
  const errorMessage = String(data?.errorMessage || '').trim()
  const detailMessage = String(data?.details?.message || '').trim()
  const detailFields = Array.isArray(data?.details?.fields)
    ? data.details.fields.map((field) => String(field).trim()).filter(Boolean)
    : []
  const fieldSuffix = detailFields.length ? ` (${detailFields.join(', ')})` : ''
  const legacyMessage = String(data?.message || '').trim()
  const legacyError = String(data?.error || '').trim()

  if (errorCode === 'E_ARTIFACT_STORAGE_QUOTA_EXCEEDED') {
    if (data?.details?.storage_scope === 'site') {
      return 'Upload abgelehnt: Das Speicherlimit von 25 GB für diese Betriebsstätte ist erreicht.'
    }
    return 'Upload abgelehnt: Das Speicherlimit von 1 GB für unternehmensweite Artefakte dieser Organisation ist erreicht.'
  }

  if (status === 413 || errorCode === 'E_FILE_TOO_LARGE' || legacyError === 'file_too_large') {
    return detailMessage || errorMessage || legacyMessage || `Datei zu groß. Maximal ${uploadFileLimitLabel} pro Datei.`
  }

  if (errorCode === 'E_ACCOUNT_ACTIVATION_REQUIRED') {
    return 'Das Konto wurde noch nicht aktiviert. Bitte fordern Sie einen neuen Aktivierungslink bei Ihrem Administrator an.'
  }

  if (errorMessage) return `${errorMessage}${fieldSuffix}`
  if (detailMessage) return `${detailMessage}${fieldSuffix}`
  if (legacyMessage) return `${legacyMessage}${fieldSuffix}`
  if (legacyError) return `${legacyError}${fieldSuffix}`
  if (errorCode) return `${errorCode}${fieldSuffix}`
  return `HTTP ${status}`
}
